/** Popsy Kids — Size Chart */
class PopsyProductSizeChart extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.trigger = this.querySelector('[data-popsy-size-chart-trigger]');
    this.dialogComponent = this.querySelector('[data-popsy-size-chart-dialog-component]');
    this.content = this.querySelector('[data-popsy-size-chart-content]');

    if (!this.trigger || !this.dialogComponent || !this.content || !this.#populateChart()) {
      this.hidden = true;
      return;
    }

    const sizeLegend = this.#findSizeLegend();
    if (!sizeLegend) {
      this.hidden = true;
      return;
    }

    sizeLegend.classList.add('popsy-size-chart__legend');
    sizeLegend.append(this.trigger);
    this.trigger.addEventListener('click', this.#openDialog);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.#openDialog);
  }

  #openDialog = () => {
    this.dialogComponent?.showDialog();
  };

  #findSizeLegend() {
    const productRoot = this.closest('.product-information') || this.closest('.shopify-section') || document;
    const legends = productRoot.querySelectorAll('variant-picker .variant-option > legend');

    return [...legends].find((legend) => {
      const optionName = legend.childNodes[0]?.textContent?.trim().toLowerCase();
      return optionName === 'size' || optionName === 'sizes' || optionName === 'age';
    });
  }

  #populateChart() {
    const metafieldTemplate = this.querySelector('template[data-popsy-size-chart-metafield]');
    const metafieldContent = metafieldTemplate?.content.cloneNode(true);

    if (metafieldContent?.textContent?.trim() || metafieldContent?.querySelector?.('img, table')) {
      this.content.append(metafieldContent);
      return true;
    }

    const descriptionTemplate = this.querySelector('template[data-popsy-size-chart-description]');
    const sourceImages = descriptionTemplate ? [...descriptionTemplate.content.querySelectorAll('img[src]')] : [];

    // Current catalog fallback is intentionally conservative: exactly one sourced image.
    if (sourceImages.length !== 1) return false;

    const chartImage = sourceImages[0].cloneNode(true);
    chartImage.removeAttribute('width');
    chartImage.removeAttribute('height');
    chartImage.loading = 'eager';
    this.content.append(chartImage);
    this.#hideDuplicateDescriptionImage(chartImage.src);
    return true;
  }

  #hideDuplicateDescriptionImage(sourceUrl) {
    const productRoot = this.closest('.product-information') || this.closest('.shopify-section') || document;
    const normalizedSource = new URL(sourceUrl, window.location.origin).href;

    productRoot.querySelectorAll('.text-block img[src]').forEach((image) => {
      if (this.contains(image)) return;
      if (new URL(image.src, window.location.origin).href !== normalizedSource) return;
      image.hidden = true;
      image.dataset.popsySizeChartSource = 'true';
    });
  }
}

if (!customElements.get('popsy-product-size-chart')) {
  customElements.define('popsy-product-size-chart', PopsyProductSizeChart);
}
